import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Header from "./components/Header";
import ErrorBoundary from "./components/ErrorBoundary";
import AppRoutes from "./routes";
import Monitor from "./pages/Monitor";

function App() {
  return (
    <Router>
      <div className="App">
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        
        <main style={{ minHeight: 'calc(100vh - 56px)' }}>
          <AppRoutes />
        </main>

        <ErrorBoundary>
          <Monitor/>
        </ErrorBoundary>
      </div>
    </Router>
  );
}

export default App;
